var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('embed-viewer-route-view',{attrs:{"url":'https://tourmake.net/de/tour/a786008b4a652636d1b5fb8081c3b5af',"title":_vm.$t('EnhancedDemoTitle'),"can-go-back":_vm.canGoBack}})}
var staticRenderFns = []

export { render, staticRenderFns }